module.exports = __webpack_public_path__ + "img/mango-icon.0a9dd46c.png";